import { FunctionComponent } from 'react';
import Program from 'wwg-utilities/dist/collections/program';
import { requirementsIcon } from '../../../lib/config/project/requirements';

import CircleIcon from '../../icons/Circle';

interface RequirementsProps {
    program: Program;
}

const Requirements: FunctionComponent<RequirementsProps> = ({
    program,
}) => {
    const admissionRequirements = program.admissionRequirements;
    const requirements = admissionRequirements?.requirements || [];
    return (
        <div className="flex flex-wrap my-4">
            {requirements.map((requirement: string) => {
                return (
                    <div
                        key={requirement}
                        className="flex items-center m-2 font-light font-base"
                    >
                        <CircleIcon
                            icon={requirementsIcon}
                            className="p-2 bg-requirements"
                        />
                        &nbsp;&nbsp;&nbsp;{requirement}
                    </div>
                );
            })}
        </div>
    );
};

export default Requirements;
